var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('FormPanel',{attrs:{"data":_vm.data,"selectItem":_vm.selectItem,"noModel":_vm.noModel,"hideModel":_vm.hideModel,"selectForm":_vm.selectForm,"startType":_vm.startType},on:{"handleSetSelectItem":_vm.handleSetSelectItem}})}
var staticRenderFns = []

export { render, staticRenderFns }